import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-40);
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-20);
`;

export const Warning = styled.p`
  svg {
    float: left;
    margin: 1px var(--sizes-10) 0 0;
  }
  color: var(--color-blue-80);
  background-color: var(--color-blue-10);
  border-radius: 3px;
  padding: var(--sizes-20);
  font-size: 11px;
`;

export const LabelWithWarning = styled.span`
  svg {
    float: right;
    margin: 0 0 0 var(--sizes-10);
  }
`;

export const FlexColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-20);
  > label {
    align-self: flex-start;
  }
`;

export const DatePickersWrapper = styled.div`
  display: flex;
  gap: var(--sizes-40);
`;

export const Disclaimer = styled.p`
  font: var(--font-extra-small-12pt-normal);
  color: var(--color-gray-70);
`;
